import { t } from 'i18next';

export const formatDeliveryAddress = address =>
  address?.textAddress &&
  `${address.textAddress}${address.apartmentDetails ? ` / ${address.apartmentDetails}` : ''}`;

export const getDispatchDescription = (
  isDelivery,
  { hotspot: isHotspot, name: storeName, textAddress, deliveryInstructions, papacar: isPapaCar },
  currentAddress
) => {
  let details = null;
  let titleKey = null;
  if (isHotspot && !isPapaCar) {
    details = `${storeName} - ${textAddress}.\n${deliveryInstructions}.`;
    titleKey = 'pickUpAtHotspot';
  } else if (isPapaCar) {
    details = `${storeName} - ${textAddress}.\n${deliveryInstructions}.`;
    titleKey = 'pickUpAtPapaCar';
  } else if (isDelivery) {
    details = currentAddress && formatDeliveryAddress(currentAddress);
    titleKey = 'delivery';
  } else {
    details = textAddress;
    titleKey = 'pickUpAt';
  }
  return {
    title: t(`DispatchDetails:${titleKey}`, {
      store: storeName,
      interpolation: { escapeValue: false }
    }),
    details,
    dispatchNote: currentAddress?.dispatchNote
  };
};
